module.exports = __webpack_public_path__ + "static/media/Screen3_left.3fb64e07.png";